import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';

import { User } from '../_models';
import { HttpHeaders } from '@angular/common/http';
import { ListTest } from '../interface/testinterface'
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
//@Injectable({ providedIn: 'root' })
@Injectable()
export class NotificationService {

    constructor(private http: HttpClient) { }

    getnotificationlist(page: number, pageSize: number,notificationfilter){
        const formData = new FormData();
        formData.append('page',page.toString());
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken;
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':atob(utoken),
                'usermasterid':atob(usermasterid),
                'notificationtitle':notificationfilter.notificationtitle,
                'status':notificationfilter.notificationstatus,
                'appname':notificationfilter.appname,
                'screenname':notificationfilter.screenname,
                'content':notificationfilter.ncontent,
            })
        }
        return this.http.post<any>(environment.url+`listNotificationMaster`,formData,httpOptions)
    }

    createnotification(notification){
        const formData = new FormData();
        formData.append('notificationtitle',notification.notificationtitle);
        formData.append('content',notification.content);
        formData.append('status',notification.status);
        formData.append('screenname',notification.screenname);
        formData.append('apptype',notification.appname);
        formData.append('smscontent',notification.smscontent);
        formData.append('smsstatus',notification.smsstatus);
        formData.append('nid',notification.nid);
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken;
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':  atob(utoken),
                'usermasterid': atob(usermasterid),
            })
        };
        return this.http.post<any>(environment.url+`addEditNotificationMaster`,formData,httpOptions)
    }

    geteditnotificationdata(nid:any){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken;
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':  atob(utoken),
                'usermasterid':atob(usermasterid),
                'nid':nid,
            })
        }
        return this.http.post<any>(environment.url+`getNotificationMasterDetails`,'',httpOptions).pipe(catchError(this.handleError));
    }

    updatestatus(notificationId:string,status:any){
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let usermasterid=currentUser.user_master_id;
        let utoken=currentUser.utoken;
        const httpOptions = {
            headers: new HttpHeaders({
                'utoken':  atob(utoken),
                'loginuserid':  atob(usermasterid),
                'tblname':'tbl_notification_contents',
                'comparecolumnname':'nid',
                'comparecolumndata':notificationId,
                'statuscolumnname':'status',
                'statusdata':status,
            })
        }
        return this.http.post<any>(environment.url+`changeStatus`,'',httpOptions).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return Observable.throw(errMessage);
        }
        return Observable.throw(error || 'Node.js server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/notification.service.ts